import { Route, Routes, Navigate } from "react-router-dom";
import Layout from './Layout/layout';
import Passengers from './Components/passengers/Passengers';
import Billing from "./Components/billing/Billing";
import Payments from "./Components/payments/Payments";
import Enjoy from "./Components/enjoy/Enjoy";

const Checkout = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="passengers" element={<Passengers />} />
        <Route path="billing" element={<Billing />} />
        <Route path="payments" element={<Payments/>}/>
        <Route path="enjoy" element={<Enjoy/>}/>
        <Route path="*" element={<Navigate to="/home" />}/>
      </Route>
    </Routes>
  );
};

export default Checkout;
